<template>
  <div class="position-relative">
    <!-- Card containing search and header -->
    <b-card class="mt-4">

      <!-- Email Search Input -->
      <div class="mb-4" style="max-width: 400px;">
        <label class="font-weight-bold">Search by Student Email:</label>
        <div class="input-group">
          <input v-model="searchEmail" type="text" class="form-control" placeholder="Enter Student Email"
            @keyup.enter="retrieveStudentLedger" />
          <span class="input-group-text" style="cursor: pointer;" @click="retrieveStudentLedger">
            <i class="fas fa-search text-primary"></i>
          </span>
        </div>
      </div>
    </b-card>

    <!-- Message when no ledger is found -->
    <div v-if="isLedgerNotFound" class="text-danger mb-3">
      No ledger found for the student with this email.
    </div>

    <!-- Ledger Section -->
    <div v-if="ledgerList.length">

      <!-- Latest Ledger -->
      <div class="border rounded p-4 bg-white shadow-sm mb-4">

        <!-- Dues Summary -->
        <div v-if="calculateDueAmount > 0" class="alert alert-danger font-weight-bold text-center mb-4">
          DUE AMOUNT: {{ formatAmount(calculateDueAmount) }}
        </div>
        <div v-else class="alert alert-success font-weight-bold text-center mb-4">
          NO DUES PENDING ✅
        </div>

        <!-- Student Details -->
        <div class="mb-4">
          <h5 class="border-bottom pb-2">Student Information</h5>
          <div class="row">
            <div class="col-md-6">
              <strong>Full Name: </strong>
              <span>
                {{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.institution_user.first_name }}
                {{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.institution_user.last_name }}
              </span>
            </div>
            <div class="col-md-6">
              <strong>Admission Number: </strong>
              <span>
                {{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.institution_user.admission_no }}
              </span>
            </div>
            <div class="col-md-6">
              <strong>Fee Category: </strong>
              <span>{{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.feecategory.name }}</span>
            </div>
            <div class="col-md-6">
              <strong>Academic Year: </strong>
              <span>
                {{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.feecategory.academic_year }} -
                {{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.feecategory.academic_semester }}
              </span>
            </div>
            <div class="col-md-6">
              <strong>Email: </strong>
              <span>{{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.institution_user.email }}</span>
            </div>
            <div class="col-md-6">
              <strong>Mobile Number: </strong>
              <span>{{ ledgerList[0].fee_transactions[0].fee_student_category_mapping.institution_user.mobile }}</span>
            </div>
          </div>
        </div>
        <h5 class="text-success">Latest Ledger #{{ ledgerList[0].ledger_number }}</h5>
        <!-- Fee Breakdown Table -->
        <div class="row">
          
  <!-- Table Left Side -->
  <div class="col-md-7">
    <h5 class="border-bottom pb-2 mb-3 font-weight-bold">Fee Details</h5>
   
      <table class="table table-sm table-bordered bg-white">
        <thead class="thead-light">
          <tr>
            <th class="align-middle">Component</th>
            <th class="text-right align-middle">Debit (₹)</th>
            <th class="text-right align-middle">Credit (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(group, fee_component_id) in getGroupedTransactions(ledgerList[0])"
            :key="fee_component_id"
          >
            <td class="align-middle">{{ group[0].fee_component.name }}</td>
            <td class="text-right align-middle">{{ formatAmount(getTotal(group, 'debit_amount')) }}</td>
            <td class="text-right align-middle">{{ formatAmount(getTotal(group, 'credit_amount')) }}</td>
          </tr>
        </tbody>
      </table>
   
  </div>

  <!-- Fee Collection Summary Right Side -->
  <div class="col-md-5">
    <div
      v-if="ledgerList[0].fee_collections.length > 0"
      class="mt-md-4 mt-3 p-3 border rounded bg-light"
    >
    <h6 class="mb-3 text-success">Collection Details</h6>
      <p class="mb-1">
        <strong>Collected On:</strong> {{ formatDate(ledgerList[0].fee_collections[0].collected_date) }}
      </p>
      <p class="mb-1">
        <strong>Collected By:</strong> {{ ledgerList[0].fee_collections[0].collected_by.first_name }} {{ ledgerList[0].fee_collections[0].collected_by.last_name }}
      </p>
      <p class="mb-1">
        <strong>Payment Mode:</strong> {{ getPaymentModeText(ledgerList[0].fee_collections[0].payment_mode) }}
      </p>
      <p class="mb-1">
        <strong>Fee Collected:</strong> {{ formatAmount(ledgerList[0].fee_collections[0].fee_collected) }}
      </p>
      <p class="mb-0">
        <strong>Balance:</strong> {{ formatAmount(ledgerList[0].fee_collections[0].balance_amount) }}
      </p>
     
    </div>
  </div>
</div>

      </div>

      <!-- Toggle Previous Ledgers -->
      <div v-if="ledgerList.length > 1" class="mb-3 text-right">
        <a href="#" @click.prevent="showAllLedgers = !showAllLedgers"
          class="btn btn-link text-primary font-weight-bold">
          {{ showAllLedgers ? 'Hide Previous Ledgers' : 'Show All Ledgers' }}
        </a>
      </div>

      <!-- Display Previous Ledgers -->
      <div v-if="showAllLedgers">
        <div
  v-for="(ledger) in ledgerList.slice(1)"
  :key="ledger.ledger_number"
  style="border: 1px solid #dee2e6; border-radius: 0.5rem; background-color: #fff; padding: 1.5rem; margin-bottom: 1.5rem;"
>


  <h5 class="text-muted">Ledger #{{ ledger.ledger_number }}</h5>

  <div class="row">
  <!-- Fee Details Table -->
  <div class="col-md-7">
    <h5 class="border-bottom pb-2 mb-3 font-weight-bold">Fee Details</h5>
   
      <table class="table table-sm table-bordered bg-white">
        <thead class="thead-light">
          <tr>
            <th class="align-middle px-3 py-2">Component</th>
            <th class="text-right align-middle px-3 py-2">Debit (₹)</th>
            <th class="text-right align-middle px-3 py-2">Credit (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(group, fee_component_id) in getGroupedTransactions(ledger)"
            :key="fee_component_id"
          >
            <td class="align-middle px-3 py-2">{{ group[0].fee_component.name }}</td>
            <td class="text-right align-middle px-3 py-2">{{ formatAmount(getTotal(group, 'debit_amount')) }}</td>
            <td class="text-right align-middle px-3 py-2">{{ formatAmount(getTotal(group, 'credit_amount')) }}</td>
          </tr>
        </tbody>
      </table>
   
  </div>

  <!-- Collection Summary -->
  <div class="col-md-5" v-if="ledger.fee_collections && ledger.fee_collections.length > 0">
    <div class="mt-md-4 mt-3">
      
      <ul class="list-unstyled">
        <li
          v-for="collection in ledger.fee_collections"
          :key="collection.id"
          class="mb-3 p-3 border rounded bg-light"
        >
        <h6 class="mb-3 text-success">Collection Details</h6>
          <p class="mb-1">
            <strong>Collected On:</strong> {{ formatDate(collection.collected_date) }}
          </p>
          <p class="mb-1" v-if="collection.collected_by">
            <strong>Collected By:</strong>
            {{ collection.collected_by.first_name }} {{ collection.collected_by.last_name }}
          </p>
          <p class="mb-1">
            <strong>Payment Mode:</strong>
            {{ getPaymentModeText(collection.payment_mode) }}
          </p>
          <p class="mb-1">
            <strong>Fee Collected:</strong> {{ formatAmount(collection.fee_collected) }}
          </p>
          <p class="mb-0">
            <strong>Balance:</strong> {{ formatAmount(collection.balance_amount) }}
          </p>
          
          
        </li>
      </ul>
    </div>
  </div>
</div>


  </div>
</div>

      
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchEmail: '',              // User input for searching by email
      ledgerList: [],               // List of student ledgers
      isLedgerNotFound: false,      // Flag to show 'not found' message
      isLoading: false,             // Loading state for API call
      showAllLedgers: false,        // Toggle for previous ledgers
      paymentModes: [               // Supported payment modes
        { value: '1', text: 'Cash' },
        { value: '2', text: 'Bank Transfer' },
        { value: '3', text: 'Cheque' },
      ],
    };
  },
  computed: {
    // Compute total due amount from latest ledger
    calculateDueAmount() {
      const groups = this.getGroupedTransactions(this.ledgerList[0]);
      let totalDebit = 0;
      let totalCredit = 0;

      for (const group of Object.values(groups)) {
        totalDebit += this.getTotal(group, 'debit_amount');
        totalCredit += this.getTotal(group, 'credit_amount');
      }

      return totalDebit - totalCredit;
    }
  },
  methods: {
    // Format currency to Indian format
    formatAmount(amount) {
      return Number(amount || 0).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
      });
    },

    // Calculate total debit/credit for a fee component
    getTotal(arr, key) {
      return arr.reduce((sum, t) => sum + Number(t[key] || 0), 0);
    },

    // Get text label for payment mode
    getPaymentModeText(value) {
      const mode = this.paymentModes.find((mode) => mode.value === value);
      return mode ? mode.text : value;
    },

    // Format date as DD/MM/YYYY
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [year, month, day] = dateStr.split('-');
      return `${day}/${month}/${year}`;
    },

    // Fetch student ledger by email
    async retrieveStudentLedger() {
      this.isLedgerNotFound = false;
      this.ledgerList = [];
      this.isLoading = true;

      const emailToSearch = this.searchEmail.trim();

      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/studentcategorymappings/view-ledger`;
        const response = await this.$axios.get(url, {
          params: { email: emailToSearch },
        });

        if (response.data && response.data.length > 0) {
          this.ledgerList = response.data;
        } else {
          this.isLedgerNotFound = true;
        }
      } catch (error) {
        console.error('Error fetching student ledger:', error);
        this.isLedgerNotFound = true;
      } finally {
        this.isLoading = false;
      }
    },

    // Group fee transactions by fee component ID
    getGroupedTransactions(ledger) {
      const grouped = {};
      ledger.fee_transactions?.forEach((tx) => {
        const id = tx.fee_component.id;
        if (!grouped[id]) grouped[id] = [];
        grouped[id].push(tx);
      });
      return grouped;
    },
  },
};
</script>
